import { CommonFormResult, FormFieldErrors } from '@/models/Form';
import { FieldValues, UseFormReturn, UseFormSetError } from 'react-hook-form';
import { z, ZodSchema } from 'zod';

interface Output<T extends ZodSchema> {
  success: boolean;
  fieldErrors?: FormFieldErrors;
  data?: z.output<T>;
}

export function validateFormData<T extends ZodSchema>(formData: FormData, schema: T): Output<T> {
  const data = Object.fromEntries(formData);
  const parsed = schema.safeParse(data);

  if (!parsed.success) {
    return {
      data: {},
      success: false,
      fieldErrors: parsed.error.issues.reduce((acc, current) => {
        return {
          ...acc,
          ...current?.path?.reduceRight(
            (pathAcc, key) => ({ [key]: pathAcc }),
            current.message as {}
          ),
        };
      }, {}),
    };
  }

  return { success: true, data: parsed.data };
}

export function setFormErrors(
  errors: FormFieldErrors | undefined,
  form: UseFormReturn<FieldValues, any, undefined>
) {
  if (!errors) {
    return form.clearErrors();
  }

  return Object.entries(errors).forEach(([key, value]) => {
    form.setError(key, { message: value });
  });
}
